<div class="job-order-data-state-filter-container">
  <form class="job-order-data-state-filter-form" [formGroup]="formGroup">

    <mat-label>Filters</mat-label>
    <mat-form-field>
      <input
        matInput
        placeholder="File name"
        formControlName="fileName"
        minlength="1"
      />
    </mat-form-field>

    <mat-label>Filter on date</mat-label>

    <app-date-quick-chips
      [activeKey]="activeChip"
      (rangeSelected)="applyQuickRange($event)"
    ></app-date-quick-chips>

    <mat-radio-group formControlName="date" (change)="onChange()">
      <mat-radio-button value="NONE">All</mat-radio-button>
      <mat-radio-button value="CUSTOM">Custom</mat-radio-button>
    </mat-radio-group>

    <ng-container *ngIf="formGroup.value.date === 'CUSTOM'">
      <mat-form-field appearance="outline">
        <input
          placeholder="From date"
          matInput
          [matDatepicker]="fromDate"
          formControlName="fromDate"
        />
        <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
        <mat-datepicker #fromDate></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <input
          placeholder="To date"
          matInput
          [matDatepicker]="toDate"
          formControlName="toDate"
        />
        <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
        <mat-datepicker #toDate></mat-datepicker>
      </mat-form-field>
    </ng-container>

    <button
      [disabled]="!formGroup.valid"
      class="btn"
      (click)="onApply()"
    >
      Apply
    </button>
  </form>

  <div style="padding: 0 20px 20px">
    <button class="btn-secondary" (click)="onViewAllSelected()">
      View all selected
    </button>
  </div>
</div>
